<template>
<div>
  <div class="principal" :class="(isMobile)?'sectionMovil':'sectionWeb'">
    <section>
      <form>
        <center><img src="/img/gesto/alt60px_logo-gesto2.png" style="height: 90px;"></center>
        <h5 style="color:white; text-align: center; padding-top: 5px; padding-bottom: 5px">Reestablecer su Contraseña</h5>
        <div class="inputbox">
          <input
            type="text" required
            autocomplete="off"
            v-model="usuario.rutEmpresa"
            @keyup="formatearIngresoRut"
            @keyup.enter="resetearPsw"
          >
          <label for="">Rut Empresa{{ !rutValidado?' (Invalido!)':'' }}</label>
        </div>
        <div class="inputbox">
          <input
          type="text" required
            autocomplete="Usuario"
            v-model="usuario.username"
            @keyup.enter="resetearPsw"
          >
          <label for="">Usuario</label>
        </div>
        <CRow>
          <CCol col="12" class="text-left">
            <CAlert style="max-width:250px" closeButton v-show="showMensaje" :color="tipoMensaje">{{mensajeLogin}}</CAlert>
          </CCol>
        </CRow>
        <CRow v-show="!showMensajeCambioPass" style="padding-bottom: 10px">
          <CCol class="text-rigth">
            <CButton shape="pill" style="background-color:#0b7689;color:white;"  @click="resetearPsw" :disabled="isReestablecer">
              
              {{msjSolicitandoCambio}}
            </CButton>
          </CCol>
        </CRow>
        <hr> 
        <CRow>
          <CCol>
            <CButton shape="pill"  style="background-color:#29235C; color:white;" 
                      @click="volverLogin">Volver al Login
            </CButton>
          </CCol>
        </CRow>
      </form>
    </section>
  </div>

  <!-- <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4" style="min-width:300px; max-width:300px; background-color:#3c2468; border:none" 
            text-color="white">
            <CCardBody>
              <CForm>
                <h1 style="color:white; font-size:26px;">Gesto</h1>
                <p class="text-muted" style="color:white">Reestablecer su Contraseña</p>
                <CInput
                  placeholder="Rut Empresa"
                  autocomplete="Rut Empresa"
                  v-model="usuario.rutEmpresa"
                  :is-valid="rutValidado"
                  @keyup="formatearIngresoRut"
                  @blur="validarRut"
                  @keyup.enter.native="resetearPsw"
                ></CInput>
                <CInput
                  placeholder="Usuario"
                  autocomplete="Usuario"
                  v-model="usuario.username"
                  @keyup.enter.native="resetearPsw"
                ></CInput>
                <CRow>
                  <CCol col="12" class="text-left">
                    <CAlert style="max-width:250px" closeButton v-show="showMensaje" :color="tipoMensaje">{{mensajeLogin}}</CAlert>
                  </CCol>
                </CRow>
                <CRow v-show="!showMensajeCambioPass" style="padding-bottom: 10px">
                  <CCol class="text-rigth">
                    <CButton style="background-color:#0b7689;color:white;"  @click="resetearPsw" :disabled="isReestablecer">
                      
                      {{msjSolicitandoCambio}}
                    </CButton>
                  </CCol>
                </CRow>
                <hr> 
                <CRow>
                  <CCol>
                    <CButton color="link" style="color:white;"
                              @click="volverLogin">Volver al Login
                    </CButton>
                  </CCol>
                </CRow>
                
              </CForm>
            </CCardBody>
          </CCard>

          <CCard
            color="primary"
            text-color="white"
            class="text-center py-5 d-sm-down-none"
            body-wrapper
          >
            <h1>Sistema de Reportes VAPP</h1>
            <p>Para ingresar utilice su usuario y contraseña otorgado por vapp, en caso de no disponer uno contacte a soporte de vapp al correo soporte@vapp.cl</p>
            <CButton
              color="primary"
              class="active mt-3"
            >
              Register Now!
            </CButton>
          </CCard>-->
      <!--  </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>-->

</div>
</template>

<script>
  import cons from '@/const'
  import axios from "axios"

  import * as util from '@/views/utils/utilsFunctions'
  
  import { freeSet } from '@coreui/icons'

export default {
    name: 'ReestablecerPsw',
    freeSet,
    data () {
        return {
            isMobile: false,
            isReestablecer: false,
            rutValidado: false,
            mensajeLogin: "",
            showMensaje: false,
            showMensajeCambioPass: false,
            enviandoSolicitud: false,
            msjCambiarPass: "",
            msjSolicitandoCambio: "Resetear Contraseña",
            tipoMensaje: "",
            usuario: {
                username: "",
                rutEmpresa: ""
            },
        }
    },
    beforeMount() {
      this.isMobile = util.getTipoDispositivoEsMobile()
    },
    methods: {
        volverLogin: function () {
            this.$router.push({ name: 'Login' });
        },
        resetearPsw: function(){
            this.isReestablecer = true
            if(this.usuario.username == null 
            || this.usuario.rutEmpresa == null 
            || this.usuario.username == "" 
            || this.usuario.rutEmpresa == ""){
                
            this.showMensaje = true
            this.mensajeLogin = "Ingrese correctamente sus datos"
            this.tipoMensaje = "danger"
            this.isReestablecer = false

            } else{

            this.enviandoSolicitud = true
            this.msjSolicitandoCambio = "Enviando Solicitud"

            var url = cons.port+"://" + cons.ipServer + "/resetear_psw_usuario"

            let userFormateado = this.formatoRut(this.usuario.username)
            const rutRegex = /^(\d{1,3}(?:\.\d{3})*)-([\dkK])$/;
            let usaRut = false
            if (rutRegex.test(userFormateado)) {
                usaRut = true // No cumple con el formato del RUT
            }
                
            axios({
                method: "POST", 
                "url": url,
                "data": {
                        "tipoUser": this.$route.query.user || null,
                        "idUsuario": null,
                        "username": (usaRut)?userFormateado.replace(/\./g, ''):this.usuario.username,
                        "usaRut": usaRut,
                        "rutEmpresa": this.usuario.rutEmpresa.replace(/\./g, '')
                    
                }
            }).then(result => {

                this.$notification.success(result.data.mensaje, {  timer: 10, position:"bottomRight"});
                this.isReestablecer = false
                this.msjSolicitandoCambio = "Resetear Contraseña"
                    
            }, error => {
                this.$notification.error(error.response.data.mensaje, {  timer: 10, position:"bottomRight"});
                this.isReestablecer = false
                this.msjSolicitandoCambio = "Resetear Contraseña"
            })
            
            .finally(() => {
                
            });
            }
        },
        formatearIngresoRut: function(){
            this.usuario.rutEmpresa = util.formatearRut(this.usuario.rutEmpresa)
            this.rutValidado = util.validarRut(this.usuario.rutEmpresa)
        },
        /* validarRut:function(event){
            var rutCompleto = this.usuario.rutEmpresa.replace(/\./g, '');//replace(/^0+|[^0-9kK]+/g, '').toUpperCase()
            
            if(rutCompleto == "" || rutCompleto == null){
                this.rutValidado = false
            } else{

            rutCompleto = rutCompleto.replace(/-/g,"-");

            if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)){
                this.rutValidado =  false;
                return
            }

            var tmp = rutCompleto.split('-');
            var digv = tmp[1]; 
            var rut = tmp[0];

            if ( digv == 'K' ) digv = 'k' ;
            this.rutValidado = (this.validarDv(rut) == digv )
            }
        }, */
        validarDv: function(T){
            var M=0,S=1;
            for(;T;T=Math.floor(T/10))
                S=(S+T%10*(9-M++%6))%11;
            return S?S-1:'k';
        },
        formatoRut: function(rut){
                var sRut1 = rut.replace(/\./g,"").replace(/-/g,"");      //contador de para saber cuando insertar el . o la -
                var nPos = 0; //Guarda el rut invertido con los puntos y el guión agregado
                var sInvertido = ""; //Guarda el resultado final del rut como debe ser
                var sRut = "";
                for(var i=(sRut1.length-1); i>=0; i-- ){
                    sInvertido += sRut1.charAt(i);
                    if (i == sRut1.length - 1 )
                        sInvertido += "-";
                    else if (nPos == 3)
                    {
                        sInvertido += ".";
                        nPos = 0;
                    }
                    nPos++;
                }
                for(var j = sInvertido.length - 1; j>= 0; j-- )
                {
                    if (sInvertido.charAt(sInvertido.length - 1) != ".")
                        sRut += sInvertido.charAt(j);
                    else if (j != sInvertido.length - 1 )
                        sRut += sInvertido.charAt(j);
                }
                //Pasamos al campo el valor formateado
                //rut.value = sRut.toUpperCase();
                return sRut.toUpperCase();
            }, 
    }
}
</script>

<style>

.imgr{
      -webkit-animation: 3s rotate linear infinite;
      animation: 3s rotate  linear infinite;
      -webkit-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
  }

/* Estilos base */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
}

img {
    max-width: 100%;
    height: auto;
}

/* Estilos de la estructura principal */
.principal {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-image: "/img/mix.png";
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 20px;
}

section {
    position: relative;
    max-width: 400px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.1);    
    border-radius: 20px;
    backdrop-filter: blur(55px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 3rem;
}

.sectionMovil section{
    border: none;
}
.sectionWeb section{
    border: 2px solid rgba(255, 255, 255, 0.5);
}

h1 {
    font-size: 2rem;
    color: #fff;
    text-align: center;
}

.inputbox {
    position: relative;
    margin: 20px 0;
    width: 100%;
    border-bottom: 2px solid #fff;
}

.inputbox label {
    position: absolute;
    top: 50%;
    left: 5px;
    transform: translateY(-50%);
    color: #fff;
    font-size: 0.8rem;
    pointer-events: none;
    transition: all 0.5s ease-in-out;
}

input:focus ~ label, 
input:valid ~ label {
    top: -5px;
}

.inputbox input {
    width: 100%;
    height: 30px;
    background: transparent;
    border: none;
    outline: none;
    font-size: 1rem;
    padding: 0 35px 0 5px;
    color: #fff;
}

.inputbox .c-icon, .inputbox ion-icon {
    position: absolute;
    right: 8px;
    color: #fff;
    font-size: 1.2rem;
    top: 20px;
}

.forget, .msjs {
    font-size: 0.75rem;
    color: #fff;
    display: flex;
    justify-content: space-between;
}

.forget label, .msjs label {
    display: flex;
    align-items: center;
}

.forget label input, .msjs label input {
    margin-right: 3px;
}

.forget a, .msjs a {
    color: #fff;
    text-decoration: none;
    font-weight: 600;
}

.forget a:hover, .msjs a:hover {
    text-decoration: underline;
}

button {
    width: 100%;
    height: 40px;
    border-radius: 40px;
    background-color: rgba(255, 255, 255, 1);
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.4s ease;
}

button:hover {
    background-color: rgba(255, 255, 255, 0.5);
}

.register {
    font-size: 0.9rem;
    color: #fff;
    text-align: center;
    margin: 25px 0 10px;
}

.register p a {
    text-decoration: none;
    color: #fff;
    font-weight: 600;
}

.register p a:hover {
    text-decoration: underline;
}

.version {
    font-size: 0.6rem;
    text-decoration: none;
    color: #fff;
    font-weight: 100;
}

.registrar{
    padding-bottom: 10px;
    color: white;
}

.link{
    color: #fff;
    text-decoration: underline;
}

.link:hover{
    color: #fff;
    filter: brightness(0.8);
}

/* Media Queries para pantallas más pequeñas */
@media (max-width: 768px) {
    section {
        padding: 1.5rem 2rem;
    }

    h1 {
        font-size: 1.8rem;
    }

    button {
        height: 35px;
    }
}

@media (max-width: 480px) {
    section {
        padding: 1rem 1.5rem;
    }

    h1 {
        font-size: 1.5rem;
    }

    button {
        height: 30px;
        font-size: 0.9rem;
    }
}

</style>
